export const styles = (theme) => ({
    root: {
      marginTop: 32,
    },
    link: {
        textDecoration: "none",
        color: "#000099",
        fontSize: ".875rem",
        "&:hover": {
            textDecoration: "underline",
            color: "#009",
        },
        cursor: 'pointer'
    },
    nonLink: {
        fontSize: ".875rem",
        color: "#888",
    }
});
